export const IMAGE_SIZES = {
  cardThumb:    { w: 400, h: 300 },
  gallery:      { w: 1200, h: 900 },
  galleryThumb: { w: 400, h: 300 },
  social:       { w: 800, h: 600 },
  avatar:       { w: 200, h: 200 },
  inauguration: { w: 800, h: 500 },
} as const;

export type ImageSizeKey = keyof typeof IMAGE_SIZES;
